import { overViewData } from './yaantracSlices/overViewSlice';
import historicSlice from './yaantracSlices/historictracking';
import analyticsReducer, {
  vehicleMakeData,
  vehicleModelData
} from './yaantracSlices/analyticsSlice';
import geofenceSlice, { geofencemappingSlices } from './yaantracSlices/geofenceSlice';
import mytripsSlice, {
  activeDriversReducer,
  addTripSlice,
  completedTripReducer,
  deactivateTripSlice,
  liveStatusTripSlice,
  mappedtripDeviceSlice,
  previewTripSlice,
  scheduledTripReducer,
  shareTripSlice,
  tripDeviceSlice,
  updateTripSlice,
  tripTypesReducer,
  drivertripsdata,
  deleteTripsData,
  driverIdsReducers
} from './yaantracSlices/mytripsSlice';
import overSpeedSlice, {
  getVechiles,
  yaantracVehicleReducer
} from './yaantracSlices/overSpeedSlice';

import {
  dashboard,
  dashboardRadius,
  dashboardVehiclesCount,
  dashboardVehiclesStatus,
  mapVehicleStatus,
  tripTodaySlice,
  tripVehicleData
} from './yaantracSlices/dashboardSlice';
import speedFrequencySlice from './yaantracSlices/speedFrequencySlice';
import addGeofence from './yaantracSlices/addGeofence';
import myLocationSlice from './yaantracSlices/myLocationSlice';

import { tripshareView } from './yaantracSlices/tripViewSlice';
import {
  alertReportsData,
  detailedtripReportsData,
  deviceHealthReportsData,
  devicesData,
  driverIdentificationReportsData,
  driverScorecardReportsData,
  engineReportsData,
  excelURL,
  getPDFExcelData,
  idleReportsData,
  kmReportsData,
  movementReportsData,
  overallReportsData,
  overspeedReportsData,
  parkingReportsData,
  pdfURL,
  reportDialog,
  stoppageReportsData,
  tripComplianceReportsData,
  vehicleDetailsReportsData,
  vehicleGeofenceReportsData
} from './yaantracSlices/reportSlice';
import tripTrackingSlice from './yaantracSlices/tripTrackingSlice';

import {
  singleVehcileDetailsSlice,
  vehcileDetailsSlice
} from './yaantracSlices/vehicleList';

export const yaantracReducer = {
  analytics: analyticsReducer,
  overview: overViewData,
  geofences: geofenceSlice,
  geofencemapping: geofencemappingSlices,
  addGeofence: addGeofence,
  trips: mytripsSlice,
  todayTrips: tripTodaySlice,
  tripsDeviceList: tripDeviceSlice,
  mappedDeviceList: mappedtripDeviceSlice,
  dashboard: dashboard,
  speedFrequency: speedFrequencySlice,
  activeDrivers: activeDriversReducer,
  overSpeed: overSpeedSlice,
  dashboardVehiclesCount: dashboardVehiclesCount,
  dashboardVehiclesStatus: dashboardVehiclesStatus,
  myLocations: myLocationSlice,
  dashboardRadius: dashboardRadius,
  previewTrip: previewTripSlice,
  addTripSlice: addTripSlice,
  drivertripsdata: drivertripsdata,
  updateTripSlice: updateTripSlice,
  deactivateTripSlice: deactivateTripSlice,
  shareTripSlice: shareTripSlice,
  liveStatusTripSlice: liveStatusTripSlice,
  mapVehiclestatus: mapVehicleStatus,
  historic: historicSlice,
  vehiclemake: vehicleMakeData,
  vehiclemodel: vehicleModelData,
  tripTypes: tripTypesReducer,
  scheduledTrip: scheduledTripReducer,
  completedTrip: completedTripReducer,
  deleteTrips: deleteTripsData,
  getVechiles: getVechiles,
  updateYaantrac: yaantracVehicleReducer,
  tripVehicle: tripVehicleData,
  tripViewPath: tripshareView,
  devicelist: devicesData,
  KM: kmReportsData,
  Stoppage: stoppageReportsData,
  Engine: engineReportsData,
  Idle: idleReportsData,
  Movement: movementReportsData,
  Parking: parkingReportsData,
  Overspeed: overspeedReportsData,
  Overall: overallReportsData,
  Alert: alertReportsData,
  TripDetails: detailedtripReportsData,

  VehicleDetails: vehicleDetailsReportsData,
  DeviceHealth: deviceHealthReportsData,
  VehicleGeofence: vehicleGeofenceReportsData,
  DriverScorecard: driverScorecardReportsData,
  reportDialog,
  pdfURL: pdfURL,
  excelURL: excelURL,
  pdfExcel: getPDFExcelData,
  DriverIdentification: driverIdentificationReportsData,
  TripCompliance: tripComplianceReportsData,
  tripTrackingSlice: tripTrackingSlice,
  vehicleList: vehcileDetailsSlice,
  driverIds: driverIdsReducers,
  singleVehcileDetails: singleVehcileDetailsSlice
  // inspection: inspectionSlice,
};
